import { compose, pure, withHandlers, withProps, withState } from 'recompose';

import { hoc as settingsHoc } from 'state/settings';
import Calendar from 'components/Calendar/component';
import { withTranslation } from 'react-i18next';

const TAB_KEY = 9;

export const CALENDAR_MODIFIERS = {
  higherPrice: 'higher price',
};

const enhance = compose(
  withState(
    'showHigherPriceWeekendMessage',
    'setShowHigherPriceWeekendMessage',
    false
  ),
  withState(
    'showHigherPriceTodayMessage',
    'setShowHigherPriceTodayMessage',
    false
  ),
  pure,
  settingsHoc.withLocale,
  withTranslation('timePickers'),
  withHandlers({
    handleDayMouseEnter:
      ({ setShowHigherPriceWeekendMessage, setShowHigherPriceTodayMessage }) =>
      (day, { higherPriceWeekend, higherPriceToday }) => {
        if (higherPriceWeekend) {
          setShowHigherPriceWeekendMessage(true);
        } else if (higherPriceToday) {
          setShowHigherPriceTodayMessage(true);
        }
      },
    handleDayMouseLeave:
      ({ setShowHigherPriceWeekendMessage, setShowHigherPriceTodayMessage }) =>
      () => {
        setShowHigherPriceWeekendMessage(false);
        setShowHigherPriceTodayMessage(false);
      },
  }),
  withProps(
    ({
      minDate,
      maxDate,
      close,
      modifiers,
      disableWeekends,
      disabledDays,
    }) => ({
      fromMonth: minDate,
      toMonth: maxDate,
      month: minDate,
      modifiers: {
        ...(modifiers && modifiers.includes(CALENDAR_MODIFIERS.higherPrice)
          ? {
              higherPriceWeekend: {
                daysOfWeek: [0, 6],
              },
              higherPriceToday: new Date(),
            }
          : {}),
      },
      handleKeyDown: (e) => {
        if (
          e.target &&
          e.target.classList.contains('DayPicker-Day') &&
          TAB_KEY === 9
        ) {
          close();
        }
      },
      handleBlur: (e) => {
        if (
          (e.target && e.target.classList.contains('DayPicker-NavButton')) ||
          (e.relatedTarget &&
            e.relatedTarget.classList.contains('DayPicker-NavButton')) ||
          (e.target && e.target.classList.contains('DayPicker-Day')) ||
          (e.relatedTarget &&
            e.relatedTarget.classList.contains('DayPicker-Day'))
        ) {
          return;
        }
        close();
      },
      disabledDays: [
        {
          before: minDate,
          after: maxDate,
        },
        disabledDays,
        disableWeekends && { daysOfWeek: [0, 6] },
        ...(disabledDays ? disabledDays.map((date) => new Date(date)) : []),
      ],
    })
  )
);

export default enhance(Calendar);
